import { PalletOptimizer } from './palletOptimizer';
import { sampleBoxes } from './sampleData';

export const testOptimizer = () => {
  console.log('🧪 Testing Pallet Optimizer...');
  
  const optimizer = new PalletOptimizer();
  
  // Add sample boxes
  sampleBoxes.forEach(box => {
    optimizer.addBox(box);
    console.log(`📦 Added box: ${box.length}×${box.width}×${box.height} cm (${box.quantity} units)`);
  });
  
  // Run optimization
  const result = optimizer.optimize();
  
  console.log('\n📊 Optimization Results:');
  console.log(`Total Pallets: ${result.totalPallets}`);
  console.log(`Efficiency: ${result.efficiency.toFixed(1)}%`);
  
  result.pallets.forEach((pallet, index) => {
    console.log(`\n📦 Pallet ${index + 1}:`);
    console.log(`  Total Height: ${pallet.totalHeight} cm`);
    console.log(`  Remaining Height: ${pallet.remainingHeight} cm`);
    console.log(`  Layers: ${pallet.layers.length}`);
    
    pallet.layers.forEach((layer, layerIndex) => {
      console.log(`    Layer ${layerIndex + 1}: ${layer.boxes.length} boxes (${layer.height} cm)`);
    });
  });
  
  return result;
}; 